import * as React from 'react';
import { SpaceProps } from 'styled-system';

import { BaseModule } from '@packages/common';
import { CmsModule } from '../CmsModule/CmsModule';

export type CmsSlotProps = {
  name?: string;
  modules?: BaseModule[];
  space?: SpaceProps;
};

export const CmsSlot: React.FC<CmsSlotProps> = ({ modules, name, space }) => {
  if (!modules || modules.length <= 0) {
    return null;
  }

  return (
    <>
      {modules.map((module) => (
        <CmsModule isRoot={true} space={space} name={name} key={module.id} {...module} />
      ))}
    </>
  );
};
